/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ecommerce_Amazon_Tools_Copy_Title4Inputs */

const en_svc_ecommerce_amazon_tools_copy_title4 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Copy_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-generated listing copy`)
};

const ar_svc_ecommerce_amazon_tools_copy_title4 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Copy_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نصوص قوائم مولدة بالذكاء الاصطناعي`)
};

const bn_svc_ecommerce_amazon_tools_copy_title4 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Copy_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এআই-তৈরি লিস্টিং কপি`)
};

const de_svc_ecommerce_amazon_tools_copy_title4 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Copy_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-generierte Listing-Texte`)
};

const es_svc_ecommerce_amazon_tools_copy_title4 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Copy_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Textos de anuncio generados con IA`)
};

const fr_svc_ecommerce_amazon_tools_copy_title4 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Copy_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Textes d'annonce générés par IA`)
};

const pt_svc_ecommerce_amazon_tools_copy_title4 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Copy_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Textos de anúncio gerados com IA`)
};

const zh_svc_ecommerce_amazon_tools_copy_title4 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Copy_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 生成 listing 文案`)
};

const tr_svc_ecommerce_amazon_tools_copy_title4 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Copy_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YZ ile listeleme metinleri`)
};

const ru_svc_ecommerce_amazon_tools_copy_title4 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Copy_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ИИ-тексты листингов`)
};

const pl_svc_ecommerce_amazon_tools_copy_title4 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Copy_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teksty listingów generowane przez AI`)
};

/**
* | output |
* | --- |
* | "AI-generated listing copy" |
*
* @param {Svc_Ecommerce_Amazon_Tools_Copy_Title4Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ecommerce_amazon_tools_copy_title4 = /** @type {((inputs?: Svc_Ecommerce_Amazon_Tools_Copy_Title4Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ecommerce_Amazon_Tools_Copy_Title4Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ecommerce_amazon_tools_copy_title4(inputs)
	if (locale === "bn") return bn_svc_ecommerce_amazon_tools_copy_title4(inputs)
	if (locale === "de") return de_svc_ecommerce_amazon_tools_copy_title4(inputs)
	if (locale === "es") return es_svc_ecommerce_amazon_tools_copy_title4(inputs)
	if (locale === "fr") return fr_svc_ecommerce_amazon_tools_copy_title4(inputs)
	if (locale === "pt") return pt_svc_ecommerce_amazon_tools_copy_title4(inputs)
	if (locale === "zh") return zh_svc_ecommerce_amazon_tools_copy_title4(inputs)
	if (locale === "tr") return tr_svc_ecommerce_amazon_tools_copy_title4(inputs)
	if (locale === "ru") return ru_svc_ecommerce_amazon_tools_copy_title4(inputs)
	if (locale === "pl") return pl_svc_ecommerce_amazon_tools_copy_title4(inputs)
	return en_svc_ecommerce_amazon_tools_copy_title4(inputs)
});
export { svc_ecommerce_amazon_tools_copy_title4 as "svc_ecommerce-amazon-tools_COPY_title" }